import '../chunk-PZ5AY32C.js';

// src/lifecycle/mount-slot.ts
function createMountSlot() {
  let current = null;
  return {
    acquire(create) {
      if (current === null) current = create();
      return current;
    },
    peek() {
      return current;
    },
    release(instance) {
      if (current !== instance) return false;
      current = null;
      return true;
    }
  };
}

export { createMountSlot };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map